import { queryOptions, skipToken } from "@tanstack/react-query";

import { MASTER_INVALIDATION_KEY } from "@/api/queryClient";
import { getMaintenanceTagById, getMaintenanceTags } from "@/api/resources/maintenanceTags/api";
import i18n from "@/providers/i18n";

const entity = i18n.t("maintenance-tags");
const entityErrorMessage = {
  text: i18n.t("notify.error-reason.unexpected"),
  title: i18n.t("notify.get.error", { e: entity }),
};
const entities = i18n.t("maintenance-tags");
const entitiesErrorMessage = {
  text: i18n.t("notify.error-reason.unexpected"),
  title: i18n.t("notify.get.error", { e: entities }),
};

export const maintenanceTagsQueryKeys = {
  all: () => [...MASTER_INVALIDATION_KEY, "maintenanceTags"],
  lists: () => [...maintenanceTagsQueryKeys.all(), "list"],
  listAll: () => [...maintenanceTagsQueryKeys.lists(), "all"],
  byId: (id?: string) => [...maintenanceTagsQueryKeys.all(), "byId", id],
};
export const maintenanceTagsQueries = {
  listAll: () =>
    queryOptions({
      queryKey: [...maintenanceTagsQueryKeys.listAll()],
      queryFn: () => getMaintenanceTags(),

      meta: {
        errorMessage: entitiesErrorMessage,
      },
    }),
  byId: (id?: string) =>
    queryOptions({
      queryKey: [...maintenanceTagsQueryKeys.byId(id)],
      queryFn: id ? () => getMaintenanceTagById(id) : skipToken,

      meta: {
        errorMessage: entityErrorMessage,
      },
    }),
};
